// EN-796: mirrors App\Enum\ProfileLevel::isAboveSenior() on the backend — a
// track (IC vs Management) only applies to Manager and Director+, since
// that's where a function like Engineering splits into two paths.
export const ABOVE_SENIOR_LEVELS = ['manager', 'director_plus'];

// The seniority levels and tracks a resume can be scored at (App\Enum\ProfileLevel and
// App\Enum\ProfileTrack). They rarely change, so they're defined here rather than fetched.
export const LEVEL_OPTIONS = [
	{ value: 'entry', label: 'Entry' },
	{ value: 'mid', label: 'Mid' },
	{ value: 'senior', label: 'Senior' },
	{ value: 'manager', label: 'Manager' },
	{ value: 'director_plus', label: 'Director+' },
];

export const TRACK_OPTIONS = [
	{ value: 'ic', label: 'Individual Contributor' },
	{ value: 'management', label: 'Management' },
];

// EN-814: the Target Role option that swaps the catalog pick for a free-text title.
export const OTHER_ROLE = 'Other';

export const isAboveSenior = (level) => ABOVE_SENIOR_LEVELS.includes(level);

export const levelLabel = (level) => LEVEL_OPTIONS.find((option) => option.value === level)?.label ?? null;

// Pure gate, kept side-effect free so it's easy to unit test — mirrors the
// server-side validation in ResumeController::setTargetSelection() (a catalog
// specialization or an "Other" title, track required above Senior, ignored
// otherwise).
export const canSubmitTargetSelection = ({ specialization, title, level, track }) => {
	const hasRole = specialization === OTHER_ROLE ? Boolean(title?.trim()) : Boolean(specialization);

	if (!hasRole || !level) {
		return false;
	}

	return !isAboveSenior(level) || Boolean(track);
};
